export default __webpack_public_path__ + "static/media/photo-background.37936d94.svg";